import React from "react";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "../../lib/api";

const TILES = [
  { src: "/insta/insta-1.jpg", post: "https://www.instagram.com/p/Db6IM-lozXY/" },
  { src: "/insta/insta-2.jpg", post: "https://www.instagram.com/p/DbqTtf6tdGB/" },
  { src: "/insta/insta-3.jpg", post: "https://www.instagram.com/p/DbpK6UHxaJJ/" },
  { src: "/insta/insta-4.jpg", post: "https://www.instagram.com/p/DbdojelmF13/" },
  { src: "/insta/insta-5.jpg", post: "https://www.instagram.com/p/DbOOAgaNnfK/" },
  { src: "/insta/insta-6.jpg", post: "https://www.instagram.com/p/Db4XTdJtAv5/" },
];

export const InstaGrid = () => (
  <section className="py-12 sm:py-16" data-testid="instagram-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
      <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">On Instagram</p>
      <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3">Follow the Ilkal Story</h2>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 sm:gap-3 mt-7">
        {TILES.map((t, i) => (
          <a
            key={i}
            href={t.post}
            target="_blank"
            rel="noreferrer"
            data-testid={`insta-tile-${i}`}
            className="group relative aspect-square overflow-hidden bg-surface"
          >
            <img src={t.src} alt="RV Ilkal Sarees on Instagram" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <span className="absolute inset-0 bg-maroon/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <Instagram className="w-6 h-6 text-ivory" strokeWidth={1.5} />
            </span>
          </a>
        ))}
      </div>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="insta-follow-link"
        className="inline-flex items-center gap-2 mt-8 text-xs tracking-[0.2em] uppercase text-maroon underline underline-offset-8 hover:text-maroon-dark"
      >
        <Instagram className="w-4 h-4" strokeWidth={1.5} /> Follow @RVILKALSAREES
      </a>
    </div>
  </section>
);
